<template>
  <div class="home-page">
    <staticBanner></staticBanner>
    <core-ability></core-ability>
    <coop-solution></coop-solution>
    <product-solution></product-solution>
    <achievment></achievment>
    <success-demo></success-demo>
  </div>
</template>
<script>
import staticBanner from './components/banner/static-banner.vue'
import coreAbility from './components/core-ability/core-ability'
import productSolution from './components/product-solution/product-solution'
import achievment from './components/achievment/achievment'
import successDemo from './components/success-demo/success-demo'
import coopSolution from './components/coop-solution/coop-solution'
export default {
    components: { staticBanner, coreAbility, productSolution, achievment, successDemo, coopSolution }
}
</script>